<template>

  <th class="text-truncate">
    <a
      href="javascript:void(0)"
      @click="setSort"
      :class="{'text-dark': isCurrent, 'text-secondary': !isCurrent}">
      <slot></slot>
      <span :style="{'visibility': isCurrent?'visible':'hidden'}">
        <i class="fas fa-sort-amount-up" v-if="isAsc" />
        <i class="fas fa-sort-amount-down" v-if="!isAsc" />  
      </span>
    </a>
  </th>

</template>

<script>
export default {
  name: 'SortLink',
  components: {
  },
  props: {
    'value': {
      type: String,
      default: ''
    },
    'field': {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    direction () {
      return this.value ? this.value.charAt(0) : null
    },
    isAsc () {
      return this.direction !== '-'
    },
    currentField () {
      if (this.direction === '-') return this.value.substring(1)
      else return this.value
    },
    isCurrent () {
      return this.field === this.currentField
    }
  },
  created () {
  },
  methods: {
    setSort () {
      const sort = (this.isAsc ? '-' : '') + this.field
      this.$emit('input', sort)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  display: block;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Parts/ThSort.vue